export default __webpack_public_path__ + "static/media/logo-blackOLD.f4e45f7e.svg";